import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

export default function SEOHub() {
  const { t } = useTranslation('home');
  const navigate = useNavigate();

  return (
    <section className="relative w-full py-16 md:py-24 bg-foreground-900 overflow-hidden">
      <div className="absolute inset-0 opacity-[0.06]">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20geometric%20pattern%20with%20flowing%20organic%20shapes%20in%20warm%20terracotta%20and%20cream%20tones%20modern%20art%20texture%20subtle%20gradient%20contemporary%20design%20background%20minimal%20and%20sophisticated%20boho%20inspired&width=1600&height=900&seq=seohub-bg-revamp-01&orientation=landscape"
          alt=""
          className="w-full h-full object-cover"
        />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20">
          <div className="flex-1">
            <span className="inline-block px-3 py-1 text-xs font-medium bg-primary-500/20 text-primary-300 rounded-full mb-4">
              {t('seo_hub_label')}
            </span>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-background-50 leading-tight">
              {t('seo_hub_title')}
            </h2>
            <p className="mt-4 text-sm md:text-base text-background-50/70 leading-relaxed max-w-lg">
              {t('seo_hub_desc')}
            </p>
            <button
              onClick={() => {
                navigate('/artigo/cssbuy-sheet-guia-completo');
                window.scrollTo({ top: 0, behavior: 'smooth' });
              }}
              className="mt-6 inline-flex items-center gap-2 px-6 py-3 bg-background-50 text-foreground-900 rounded-full text-sm font-semibold hover:bg-background-100 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              {t('seo_hub_read')}
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line"></i>
              </div>
            </button>
          </div>

          <div className="flex-1 w-full">
            <div className="flex gap-4 items-end">
              <span className="font-heading text-8xl md:text-9xl font-bold text-background-50/10 leading-none select-none">
                01
              </span>
              <div className="mb-2">
                <p className="text-sm text-background-50/60 leading-relaxed">
                  Nosso artigo principal aborda desde os fundamentos do CSSBuy Spreadsheet ate
                  estrategias avancadas para encontrar produtos exclusivos com os melhores precos.
                </p>
              </div>
            </div>
            <div className="mt-6 rounded-xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Elegant%20product%20still%20life%20on%20marble%20and%20brass%20surface%20with%20carefully%20curated%20fashion%20items%20warm%20candlelight%20ambiance%20rich%20texture%20layering%20editorial%20luxury%20photography%20dark%20sophisticated%20mood&width=800&height=500&seq=seohub-preview-revamp-01&orientation=landscape"
                alt="CSSBuy Spreadsheet guide preview"
                className="w-full h-auto object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}